import axios from 'axios';
import { API_URL } from '../utils/baseApi';
import authHeader from './authHeader';

export const getProjectNames = () => {
  const apiKey = localStorage.getItem('apiKey');
  return axios.get(`${API_URL}/project-names`, {
    headers: { 'x-api-key': apiKey }
  });
};

export const createProjectName = (title) => {
  return axios.post(`${API_URL}/project-names`, { title }, {
    headers: authHeader()
  });
};
